<template>
  <div class="dashboard">
    <el-row :gutter="20" class="top-block mt-20">
      <el-col :xs="24" :sm="12" :lg="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>常用功能</span>
          </div>
          <div>
            <el-col :xs="12" :sm="12" :lg="12">
              <el-table :data="dailyList" :show-header="false" stripe >
                <el-table-column label="功能" prop="name">
                   <template slot-scope="scope">
                      <router-link :to="`${scope.row.path}`"> {{scope.row.name}} </router-link>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="12">
              <el-table :data="notDailyList" :show-header="false" stripe>
                <el-table-column label="功能" prop="name">
                   <template slot-scope="scope">
                      <router-link :to="`${scope.row.path}`"> {{scope.row.name}} </router-link>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </div>
        </el-card>
      </el-col>
      
    </el-row>
  </div>
</template>

<script>
import store from "@/store";
import {removeToken} from "@/util";

export default {
  name: 'Dashboard',
  data() {
    return {
      tableData: [],
      menuTableData: [],
      dailyList:[],
      notDailyList:[],
      appVersion: localStorage.getItem('LH_VERSION')
    }
  },
  
  methods: {
    loadActionLog() {
      this.request.get("/user/log").then(res => {
        console.log(res)
        if (res.code === '200') {
          this.tableData = res.data.records
        } else {
          this.showResult('error', '無法取得使用紀錄')
        }

      })
    },
    async loadUserBadge() {
      try {
        await store.dispatch('login/getUserBadge')
      } catch (e) {
        this.showResult('error', 'load_badge_error')
      }
    },
    loadUserMenuShortCut(){
      this.request.get("/user/shortcut").then(res => {
          if (res.code === '200') {
            this.menuTableData = res.data
            
            this.dailyList = this.menuTableData.filter(data => data.daily === 'Y')
            console.log('dailyList:', this.dailyList)
            
            this.notDailyList = this.menuTableData.filter(data => data.daily === 'N')
            console.log('notDailyList:', this.notDailyList)

          } else {
            this.showResult("error", "查詢使用者功能捷徑資料失敗")
          }
      })
    },
    checkReload(){
      console.log('appVersion:', this.appVersion)
      console.log('static version:', this.version)
      if (this.appVersion === null) {
        localStorage.setItem('LH_VERSION', this.version)
        location.reload()
      } else {
        if (this.appVersion !== this.version) {
          localStorage.setItem('LH_VERSION', this.version)
          this.appVersion = this.version
          window.location.reload()
        }
      }
    },

  },
  filters: {
    transformType(value) {
      let label = ''
      switch (value) {
        case '登入':
          label = "primary"
          break;
        case '登出':
          label = "warning"
          break;
        default:
          label = "danger"
      }
      return label
    }
  },
  mounted() {
    this.checkReload()
    this.loadUserBadge();
    this.loadUserMenuShortCut()
  }
}
</script>

<style scoped>

.el-table {
  font-size:16px;
}
.dashboard >>> .el-card__body {
  padding: 20px 0px;
}


</style>
